import { useCartItemCache } from '@/features/pos/components/Cart/hooks/useCartItemCache'
import { useEditCartItemActions } from '@/features/pos/components/OrderFinalization/contexts/EditCartItemProvider'
import UIMenuButton from '@/features/ui/buttons/components/MenuButton'
import MenuItem from '@/features/ui/buttons/components/MenuButton/parts/MenuItem'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface MenuButtonProps {
    id: string
    hasAutomaticContainers: boolean
    onEditAutomaticContainers: (id: string) => void
}

const MenuButton: FC<MenuButtonProps> = ({
    id,
    hasAutomaticContainers,
    onEditAutomaticContainers,
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const cartItem = useCartItemCache(id)!

    const { t } = useTranslation()

    const { set } = useEditCartItemActions()

    const toggleIsOpen = () => setIsOpen((isOpen) => !isOpen)

    const handleEditProductPress = () => {
        set(id, cartItem.productVariant.product.uuid)

        toggleIsOpen()
    }

    const handleEditAutomaticContainersPress = () => {
        onEditAutomaticContainers(id)

        toggleIsOpen()
    }

    return (
        <UIMenuButton open={isOpen} onToggleOpen={toggleIsOpen}>
            <MenuItem
                label={t('pos.orderFinalization.cart.item.menuOptions.editProduct')}
                divider={hasAutomaticContainers}
                onPress={handleEditProductPress}
            />
            {hasAutomaticContainers && (
                <MenuItem
                    label={t('pos.orderFinalization.cart.item.menuOptions.editContainers')}
                    divider={false}
                    onPress={handleEditAutomaticContainersPress}
                />
            )}
        </UIMenuButton>
    )
}

export default MenuButton
